import React from 'react';

import './styles.scss'

import {PageTitleText} from "../../Typography";
import {MerchantRequestError} from "../../InputsHelpers";
import {Ripple} from "../../Buttons";
import {Box} from "@material-ui/core";
import Cross from "../../../icons/Cross";

export default ({title, formCtx, closeDialog}) => {
  return (
    <div className="dialog-header">
      <div className="dialog-header__left-block">
        <div className="dialog-header__title">
          <PageTitleText>{title}</PageTitleText>
        </div>
        {formCtx && (
          <div className="dialog-header__request-error">
            <MerchantRequestError formCtx={formCtx} />
          </div>
        )}
      </div>
      <div className="dialog-header__right-block">
        <Ripple onClick={closeDialog}>
          <Box width="4rem" height="4rem" display="flex" justifyContent="center" alignItems="center">
            <Cross width="1rem" height="1rem" />
          </Box>
        </Ripple>
      </div>
    </div>
  )
}
